import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
  signal,
  ViewChild,
} from '@angular/core';
import { rxEffects } from '@rx-angular/state/effects';
import { toObservable } from '@angular/core/rxjs-interop';
import { debounceTime, map, startWith, combineLatestWith } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { RouteMapEntry } from '@rx-lib/models';
import { LibSearchBoxComponent } from './search-box.component';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { rxState } from '@rx-angular/state';
import { RxFor } from '@rx-angular/template/for';
import { Page } from '../models/models';
import { fadeChild, staggerItem, staggerList } from './animations';


@Component({
  selector: 'lib-fulltext-search',
  standalone: true,
  templateUrl: './search.component.html',
  styleUrl: './search.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [LibSearchBoxComponent, RouterLink, RouterLinkActive, RxFor],
  animations: [staggerList, fadeChild, staggerItem]
})
export class FulltextSearchComponent implements OnInit {

  public state = rxState<{
    routesMap: Page[],
    resetOn: RouteMapEntry
  }>();

  readonly query = signal('');
  private readonly effects = rxEffects();

  @Input()
  set routesMap(routesMap$: Observable<Page[]>) {
    this.state.connect('routesMap', routesMap$);
  }

  @Input()
  set resetOn(resetOn$: Observable<RouteMapEntry>) {
    this.state.connect('resetOn', resetOn$);
  }

  // @Input({ required: true }) routesMap$!: Observable<Map<string, RouteMapEntry>>;
  // @Input() resetOn$: Observable<unknown> = EMPTY;
  

  @Input() minChars = 3;


  @ViewChild(LibSearchBoxComponent)
  private searchBox?: LibSearchBoxComponent;
  


  // 1. Flattened array of searchable routes
  readonly searchableRoutes$ = this.state.select('routesMap')/*.pipe(
    map((map) =>
      Array.from(map.values()).map((route) => ({
        title: route.page.title ?? '',
        url: route.page.path,
        index: route.index,
        content: route.page?.body ?? '',
      }))
    )
  )*/;

  // 2. Debounced query signal as observable
  private readonly debouncedQuery$ = toObservable(this.query).pipe(
    debounceTime(250),
    startWith('')
  );

  // 3. Final filtered results$ (debounced + flatten-once + min length)
  readonly results$ = this.debouncedQuery$.pipe(
    combineLatestWith(this.searchableRoutes$),
    map(([query, routes]) => {
      const q = query.trim().toLowerCase();
      if (q.length < this.minChars) return [];

      return routes.filter(
        (route) =>
          route.title.toLowerCase().includes(q) ||
          route.path.toLowerCase().includes(q) ||
          route.body?.toLowerCase().includes(q)
      );
    })
  );

  ngOnInit() {
    /* RESET QUERY ON ROUTE CHANGE */
    this.effects.register(this.state.select('resetOn'), () => {
      this.query.set('');
    });
  }

  focus = () => queueMicrotask(() => this.searchBox?.focus());
  
}
